import React, { lazy, Suspense } from "react";
import ApproverList from "../pages/configuration-services/ApproverList";
import AVTXOrgChart from "../pages/coda/AVTXOrgChart";
import MBOrgChart from "../pages/dashboards/OrgCharts/MBOrgChart";

const TestPage = lazy(() => import("../pages/TestPage"));

const Login = lazy(() => import("../pages/Login"));
const Signup = lazy(() => import("../pages/Signup"));
const ACEIaC = lazy(() => import("../pages/ACE/form"));
const ACEIDForm = lazy(() => import("../pages/ACE/form/UserDetailForm"));


const ResetPassword = lazy(() => import("../pages/ResetPassword"));
const ChangePassword = lazy(() => import("../pages/ChangePassword"));

const AdminDashboard = lazy(() => import("../pages/admin/AdminDashboard"));
const AdminUsers = lazy(() => import("../pages/admin/adminUsers"));
const AdminUserForm = lazy(() => import("../pages/admin/adminUsers/form"));
const Roles = lazy(() => import("../pages/admin/roles"));
const PermForm = lazy(() => import("../pages/admin/roles/AddPermForm"));

const ComplainceReportsForm = lazy(
    () => import("../pages/admin/SecurityReports/form")
);
const DocsChatbot = lazy(() => import("../pages/support/DocsChatbot"));

const MFA = lazy(() => import("../pages/MFA"));
const Edge = lazy(() => import("../pages/edge"));
const EdgeForm = lazy(() => import("../pages/edge/form"));

const HomePage = lazy(() => import("../pages/index"));
const AccountExplorer = lazy(() => import("../pages/accountExplorer"));
const AIML = lazy(() => import("../pages/AIML"));
const SecuirtyReports = lazy(() => import("../pages/secuirtyReports"));
const SecuirtyReportForm = lazy(() => import("../pages/secuirtyReports/Form"));

const FeaturedDashboards = lazy(() => import("../pages/featuredDashboards"));
const RepDashboard = lazy(
    () => import("../pages/featuredDashboards/RepDashboard")
);
const AccountUsecaseDashboard = lazy(
    () => import("../pages/featuredDashboards/AccountDashboradUsecase")
);
const AccountDeepdiveDashboard = lazy(
    () => import("../pages/featuredDashboards/AccountDeepdiveDashboard")
);

const AccountExplorer2 = lazy(
    () => import("../pages/dashboard1/AccountExplorer")
);

//const BillingSimulator = lazy(()=> import('../pages/billing/samulator'));
const UsageMatrix = lazy(() => import("../pages/billing/usage"));
//const BillingUsageMonthlyComparison = lazy(()=> import('../pages/billing/usage/monthlyComparison'));
const BillingInvoices = lazy(() => import("../pages/billing/invoices"));

const BillingConfigurator = lazy(() => import("../pages/billing/configurator"));
const BillingPlanCreator = lazy(
    () => import("../pages/billing/configurator/planCreator")
);
const StandardBillingPlan = lazy(
    () => import("../pages/billing/configurator/standardPlan")
);
const BillingAdjustment = lazy(
    () => import("../pages/billing/adjustment")
);

const BillingReport = lazy(
    () => import("../pages/billing/reports/BillingReport")
);
const BillingReportStandard = lazy(
    () => import("../pages/billing/reports/BillingReportStandard")
);
const BillingMatricsReport = lazy(
    () => import("../pages/billing/reports/BillingMatrics")
);
const SplitBillingAccounts = lazy(
    () => import("../pages/billing/splitbilling")
);
const ELP = lazy(() => import("../pages/billing/elp"));
const NodeBasedPricingELP = lazy(
    () => import("../pages/billing/elp/node_based_pricing")
);
const BVA = lazy(() => import('../pages/bva'));
const AddonServices = lazy(() => import("../pages/billing/addonServices"));
const Offers = lazy(() => import("../pages/billing/offers"));
const Quotes = lazy(() => import("../pages/billing/quotes"));
const DollarSavings = lazy(() => import("../pages/billing/dollarSavings"));
const ViewSavings = lazy(
    () => import("../pages/billing/dollarSavings/PreviewSavings/ViewSavings")
);
const ViewLogs = lazy(
    () => import("../pages/billing/dollarSavings/Logs/ViewLogs")
);

const ABUPDirect = lazy(() => import("../pages/billing/abupDirect"));

const AccountTagForm = lazy(() => import("../pages/admin/tags/form"));
const AccountTag = lazy(() => import("../pages/admin/tags"));

const SupplierLogin = lazy(
    () => import("../pages/supplierPortal/SupplierLogin")
);
const OrderForm = lazy(
    () => import("../pages/supplierPortal/orderForm/OrderForm")
);
const GridListing = lazy(() => import("../pages/supplierPortal/orderTracking"));
const OrderDetail = lazy(
    () => import("../pages/supplierPortal/orderTracking/OrderDetail")
);
const VendorGridListing = lazy(() => import("../pages/supplierPortal/vendors"));
const VendorForm = lazy(() => import("../pages/supplierPortal/vendors/form"));
const ProductGridListing = lazy(
    () => import("../pages/supplierPortal/products")
);
const ProductForm = lazy(() => import("../pages/supplierPortal/products/form"));
const SupplierReports = lazy(() => import("../pages/supplierPortal/reports"));
const ReturnsReplacement = lazy(
    () => import("../pages/supplierPortal/returnsReplacement")
);
const ReturnsReplacementsForm = lazy(
    () => import("../pages/supplierPortal/returnsReplacement/form")
);
const Devices = lazy(() => import("../pages/supplierPortal/devices"));
const Emails = lazy(() => import("../pages/supplierPortal/emails"));
const ReturnsReplacementsDetail = lazy(
    () => import("../pages/supplierPortal/returnsReplacement/detail")
);
const EmailSelector = lazy(
    () => import("../pages/supplierPortal/emails/emailselector")
);
const MeterCalculator = lazy(() => import("../pages/meterCalc"));
const ACE = lazy(() => import("../pages/ACE/certification"));
const ACEExam = lazy(() => import("../pages/ACE/exam"));
const ACEExamUserForm = lazy(() => import("../pages/ACE/exam/form"));
const ACEDashboard = lazy(() => import("../pages/ACE/dashboard"));
const ACEUserForm = lazy(() => import("../pages/ACE/certification/form"));
const ACEUserClubForm = lazy(() => import("../pages/ACE/certification/ClubForm"));
const ACECommunity = lazy(() => import("../pages/ACE/commmunity"));
const Meetings = lazy(() => import("../pages/meetings"));
const Support = lazy(() => import("../pages/support"));
const MeetingForm = lazy(() => import("../pages/meetings/form"));
const MeetingsDashboard = lazy(() => import("../pages/meetings/dashboard"));

const Telemetry = lazy(() => import("../pages/admin/telemetry"));
const TelemetryForm = lazy(() => import("../pages/admin/telemetry/form"));

const CustomerBilling = lazy(
    () => import("../pages/billing/reports/CustomerBilling")
);
const ABUPDashboard = lazy(() => import("../pages/billing/abupDashboard"));

const ValueIQ = lazy(() => import("../pages/valueIQ"));

const Logs = lazy(() => import("../pages/admin/logs"));

const QuotePreview = lazy(
    () => import("../pages/meterCalc/version3/QuotePreview")
);
const ConfigurationServices = lazy(
    () => import("../pages/configuration-services/index")
);
const ConfigurationServicesBilling = lazy(
    () => import("../pages/configuration-services/Billing")
);
const CustomerBillingApprovals = lazy(
    () => import("../pages/configuration-services/CustomerBilling")
);

//const DBCustomerGateways = lazy(()=> import('../pages/dashboards/customer_gateways'));
const CustomerTopologyGlob = lazy(
    () => import("../pages/dashboards/customer_gateways/CustomerTopologyGlob")
);

const LegalDashboard = lazy(() => import("../pages/legal/dashboard"));
const LegalAIRequest = lazy(() => import("../pages/legal/AIRequest"));
const LegalPatentRequest = lazy(() => import("../pages/legal/patent/Form"));
const LegalPatentList = lazy(() => import("../pages/legal/patent/index"));
const LegalReports = lazy(() => import("../pages/legal/reports"));

// HighVelocity
const HighVelocity = lazy(() => import("../pages/high-velocity"));

// function to redirect to an external URL
const redirectToExternalURL = (url) => {
    window.location.href = url;
};

const trustURL = "https://support.aviatrix.com/trust";

const routing: any = [
    { path: "/test", component: TestPage, exact: true, controller: "1" },

    { path: "/", component: HomePage, exact: true, controller: "1" },

    { path: "/", component: HomePage, exact: true, controller: "1" },

    { path: "/login/:p?", component: Login, exact: true },
    { path: "/changePassword/:uuid?", component: ChangePassword, exact: true },
    { path: "/resetPassword", component: ResetPassword, exact: true },
    { path: "/MFA", component: MFA, exact: true, controller: "1" },
    {
        path: ["/signup/:uuid?", "/invite/:uuid?"],
        component: Signup,
        exact: true,
    },
    { path: "/org-chart", component: AVTXOrgChart, exact: true },
    { path: "/mb-org-chart", component: MBOrgChart, exact: true },
    //{path:, component: Signup, exact: true },
    { path: "/ACE-IaC", component: ACEIaC, exact: true },
    { path: "/ACE-Details", component: ACEIDForm, exact: true },

    { path: "/admin", component: AdminDashboard, exact: true, controller: "1" },
    { path: "/admin/users", component: AdminUsers, exact: true, controller: "1" },
    {
        path: "/admin/user/id/:id?",
        component: AdminUserForm,
        exact: true,
        controller: "1",
    },
    { path: "/tags", component: AccountTag, exact: true, controller: "1" },
    {
        path: "/tags/id/:id?",
        component: AccountTagForm,
        exact: true,
        controller: "1",
    },
    { path: "/admin/roles", component: Roles, exact: true, controller: "1" },
    {
        path: "/admin/roles/addperm",
        component: PermForm,
        exact: true,
        controller: "1",
    },
    { path: "/logs", component: Logs, exact: true, controller: "1" },
    {
        path: "/security-compliance/id/",
        component: ComplainceReportsForm,
        exact: true,
        controller: "1",
    },

    {
        path: "/account-explorer/",
        component: AccountExplorer,
        exact: true,
        controller: "1",
    },

    { path: "/ai-ml/", component: AIML, exact: true, controller: "1" },

    {
        path: "/account-explorer2",
        component: AccountExplorer2,
        exact: true,
        controller: "1",
    },

    {
        path: "/featured-dashboards",
        component: FeaturedDashboards,
        exact: true,
        controller: "1",
    },
    {
        path: "/featured-dashboards/rep",
        component: RepDashboard,
        exact: true,
        controller: "1",
    },
    {
        path: "/featured-dashboards/useCase",
        component: AccountUsecaseDashboard,
        exact: true,
        controller: "1",
    },
    {
        path: "/featured-dashboards/accountDeepdive",
        component: AccountDeepdiveDashboard,
        exact: true,
        controller: "1",
    },

    {
        path: "/security-compliance-reports",
        component: SecuirtyReports,
        exact: true,
        controller: "1",
    },
    {
        path: "/security-compliance-reports/:id?",
        component: SecuirtyReportForm,
        exact: true,
        controller: "1",
    },

    //{path:'/billing/simulator', component:BillingSimulator, exact:true, controller:'1'},

    {
        path: "/billing/usage",
        component: UsageMatrix,
        exact: true,
        controller: "1",
    },
    //{path:'/billing/usage/monthly-comparison', component:BillingUsageMonthlyComparison, exact:true, controller:'1'},

    {
        path: "/billing/invoices",
        component: BillingInvoices,
        exact: true,
        controller: "1",
    },
    {
        path: "/billing/configurator",
        component: BillingConfigurator,
        exact: true,
        controller: "1",
    },
    {
        path: "/billing/configurator/plan/:id",
        component: BillingPlanCreator,
        exact: true,
        controller: "1",
    }, //editadjustment
    {
        path: "/billing/configurator/plan/create/:acid/:byModel/:bModel?",
        component: BillingPlanCreator,
        exact: true,
        controller: "1",
    }, //create
    {
        path: "/billing/configurator/standardPlan",
        component: StandardBillingPlan,
        exact: true,
        controller: "1",
    }, //create
    {
        path: "/billing/report/abu",
        component: BillingReport,
        exact: true,
        controller: "1",
    }, // report
    {
        path: "/billing/report/standard",
        component: BillingReportStandard,
        exact: true,
        controller: "1",
    }, // report
    {
        path: "/billing/report/billing-metrics",
        component: BillingMatricsReport,
        exact: true,
        controller: "1",
    }, // report
    {
        path: "/billing/split-billing",
        component: SplitBillingAccounts,
        exact: true,
        controller: "1",
    },
    { path: "/billing/elp", component: ELP, exact: true, controller: "1" },
    {
        path: "/billing/elp/node-based",
        component: NodeBasedPricingELP,
        exact: true,
        controller: "1",
    },
    {
        path: "/billing/addon-services",
        component: AddonServices,
        exact: true,
        controller: "1",
    },
    { path: "/billing/offers", component: Offers, exact: true, controller: "1" },
    { path: "/billing/quotes", component: Quotes, exact: true, controller: "1" },
    {
        path: "/billing/dollar-saving",
        component: DollarSavings,
        exact: true,
        controller: "1",
    },
    {
        path: "/billing/dollar-saving/:id",
        component: ViewSavings,
        exact: true,
        controller: "1",
    },
    {
        path: "/billing/dollar-saving/logs/:id",
        component: ViewLogs,
        exact: true,
        controller: "1",
    },

    {
        path: "/billing/direct",
        component: ABUPDirect,
        exact: true,
        controller: "1",
    },
    {
        path: "/billing/adjustment",
        component: BillingAdjustment,
        exact: true,
        controller: "1",
    },


    {
        path: "/abureports/customer-billing",
        component: CustomerBilling,
        exact: true,
        controller: "1",
    },
    {
        path: "/abup-dashboard",
        component: ABUPDashboard,
        exact: true,
        controller: "1",
    },

    { path: "/supplierportal/login", component: SupplierLogin, exact: true },
    {
        path: "/supplierportal/orderform/id/:accountId/:contactId/:opportunityId",
        component: OrderForm,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/ordertracking",
        component: GridListing,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/ordertracking/orderdetails/:id?",
        component: OrderDetail,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/vendors",
        component: VendorGridListing,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/vendors/id/:id?",
        component: VendorForm,
        exact: true,
        controller: "1",
    },
    // {path:'/supplierportal/products', component:ProductGridListing, exact:true, controller:'1'},
    // {path:'/supplierportal/products/id/:id?', component:ProductForm, exact:true, controller:'1'},
    {
        path: "/supplierportal/returnsreplacements",
        component: ReturnsReplacement,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/returnsreplacements/create/:SerialNo",
        component: ReturnsReplacementsForm,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/devices",
        component: Devices,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/emails",
        component: Emails,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/returnsreplacements/detail/:id/:serialNo",
        component: ReturnsReplacementsDetail,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/emails/edit",
        component: EmailSelector,
        exact: true,
        controller: "1",
    },
    {
        path: "/supplierportal/reports",
        component: SupplierReports,
        exact: true,
        controller: "1",
    },

    { path: "/valueIQ", component: ValueIQ, exact: true, controller: "1" },
    { path: "/ACE", component: ACE, exact: true, controller: "1" },
    {
        path: "/ACE/dashboard",
        component: ACEDashboard,
        exact: true,
        controller: "1",
    },
    {
        path: "/ACE/id/:id?",
        component: ACEUserForm,
        exact: true,
        controller: "1",
    },
    {
        path: "/ACE/club",
        component: ACEUserClubForm,
        exact: true,
        controller: "1",
    },
    { path: "/ACEExam", component: ACEExam, exact: true, controller: "1" },
    {
        path: "/ACEExam/id/:id?",
        component: ACEExamUserForm,
        exact: true,
        controller: "1",
    },
    {
        path: "/ACE/community",
        component: ACECommunity,
        exact: true,
        controller: "1",
    },

    { path: "/meetings", component: Meetings, exact: true, controller: "1" },
    {
        path: "/meeting/id/:id?",
        component: MeetingForm,
        exact: true,
        controller: "1",
    },
    {
        path: "/meetings/dashboard",
        component: MeetingsDashboard,
        exact: true,
        controller: "1",
    },

    { path: "/telemetry", component: Telemetry, exact: true, controller: "1" },
    {
        path: "/telemetry/id/:id?",
        component: TelemetryForm,
        exact: true,
        controller: "1",
    },

    {
        path: "/meterCalc",
        component: MeterCalculator,
        exact: true,
        controller: "1",
    },
    { path: "/bva", component: BVA, exact: true, controller: "1" },

    { path: "/edge", component: Edge, exact: true, controller: "1" },

    {
        path: "/legal/dashboard",
        component: LegalDashboard,
        exact: true,
        controller: "1",
    },
    {
        path: "/legal/patent-request",
        component: LegalPatentRequest,
        exact: true,
        controller: "1",
    },
    {
        path: "/legal/patents",
        component: LegalPatentList,
        exact: true,
        controller: "1",
    },
    {
        path: "/legal/patent-request/:id",
        component: LegalPatentRequest,
        exact: true,
        controller: "1",
    },

    {
        path: "/legal/ai-request",
        component: LegalAIRequest,
        exact: true,
        controller: "1",
    },
    {
        path: "/legal/reports",
        component: LegalReports,
        exact: true,
        controller: "1",
    },

    { path: "/quote/preview/:id", component: QuotePreview, exact: true },
    {
        path: "/configurations-services",
        component: ConfigurationServices,
        exact: true,
    },
    {
        path: "/configurations-services-approver",
        component: ApproverList,
        exact: true,
    },
    {
        path: "/configuration-billing",
        component: ConfigurationServicesBilling,
        exact: true,
    },
    {
        path: "/customer-billing-approval",
        component: CustomerBillingApprovals,
        exact: true,
    },

    //{ path: "/dashboards/customer-gateways", component:DBCustomerGateways, exact: true},
    {
        path: "/dashboards/topology-glob/:domain",
        component: CustomerTopologyGlob,
        exact: true,
    },

    { path: "/edge/id/:id?", component: EdgeForm, exact: true, controller: "1" },
    { path: "/chatbot", component: Support, exact: true, controller: "1" },
    {
        path: "/docs-chatbot",
        component: DocsChatbot,
        exact: true,
        controller: "1",
    },
    {
        path: "/trust-center",
        component: () => {
            redirectToExternalURL(trustURL);
        },
        exact: true,
    },
    { path: "/high-velocity", component: HighVelocity, exact: true },
];

export default routing;
